'use strict';

export default function SearchItemCompareButton({ active, disabled, onClick }) {
    return <a role='button'
        className={cn("el-flight-compare", active && 'added')}
        disabled={disabled}
        onClick={() => onClick()}>
        <i className="icon-compare3"></i>
        {__(active ? 'search.card.compared' : 'search.card.compare')}
    </a>;
}

